import { render, staticRenderFns } from "./EditProjectNameDialog.vue?vue&type=template&id=4b75eded"
import script from "./EditProjectNameDialog.ts?vue&type=script&lang=ts&external"
export * from "./EditProjectNameDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./EditProjectNameDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports